import { FC, useEffect, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap-v5'
import SVG from 'react-inlinesvg'
import { VersionInfo } from '../utils/constants';

type Props = {
    show: boolean;
    onHide: () => void
    version: VersionInfo
}

export const ChangelogModal: FC<Props> = ({ show, onHide, version }) => {
    const [tabSelected,setTabSelected] = useState<number>(1)
    
    return version && (
        <Modal show={show} centered size="lg" backdrop="static" dialogClassName="team-admin-add-member-modal">
            <div className="team-admin-add-member">
                {/* HEADER */}
                <div className="admin-experience-details-header text-center">
                    <h2 className="tap-experience-nb-modal-title">
                        Changelog
                    </h2>
                    <div className="rm-style-3 cursor-pointer" onClick={onHide}>
                        <SVG src="/media/svg/nobilis/closeX.svg" className="rm-style-4" />
                    </div>
                </div>
                {/* CONTENT */}
                <div className="team-admin-add-member__card">
                    <div className="nb-pm-tabs-header">
                        <div className="nb-pm-tabs-row">
                            <div className="nb-pm-tabs-list">
                                <div className="tap-flex-center">
                                    <div className={`nb-pm-tabs-item ${tabSelected === 1 ? 'nb-pm-tabs-item--active' : ''}`} onClick={()=>setTabSelected(1)}>
                                        <div className="nb-pm-tabs-item-text">Features</div>
                                    </div>
                                    <svg className='ml_3' width='1' height='20' viewBox='0 0 1 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                                        <path d='M0.5 0V20' stroke='#B4B4B4' />
                                    </svg>
                                    <div className={`nb-pm-tabs-item ml_2 ${tabSelected === 2 ? 'nb-pm-tabs-item--active' : ''}`} onClick={()=>setTabSelected(2)}>
                                        <div className="nb-pm-tabs-item-text">Fixes</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='bio-tabs__content tap-experience-nb-modal-text text-capitalize gap-1'>
                        {tabSelected == 1 && version?.changelog?.feat?.map((i)=><span>{i}</span>)}
                        {tabSelected == 2 && version?.changelog?.fixes?.map((i)=><span>{i}</span>)}
                        <div>
                            <span>
                                <b>version:</b> {version.version}
                            </span><br />
                            <span>
                                <b>Released:</b> {version.updatedAt}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
